import './Wishlistdrawer.css'
import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'
import { HeartIcon } from './Icons'
import { gallery, inr, pricing, stock, STOCK_LABEL } from './ProductCard'
import { useCart } from '../context/CartContext'
import { useProducts } from '../hooks/useSiteData'

// Wishlist as a panel that slides in from the right (like the cart).
// Rendered with a portal so the sticky, blurred navbar cannot trap its fixed position.
export default function WishlistDrawer() {
  const { wish, wishOpen, setWishOpen, toggleWish, dispatch } = useCart()
  const products = useProducts()
  const closeRef = useRef(null)
  const saved = products.filter(p => wish.some(id => String(id) === String(p.id)))
  const close = () => setWishOpen(false)

  useEffect(() => {
    if (!wishOpen) return
    const onKey = e => { if (e.key === 'Escape') setWishOpen(false) }
    window.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    closeRef.current?.focus()
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev }
  }, [wishOpen, setWishOpen])

  if (!wishOpen) return null

  return createPortal(
    <div className="wd" role="dialog" aria-modal="true" aria-label="Your wishlist">
      <div className="wd__scrim" onClick={close} />
      <aside className="wd__panel">
        <header className="wd__head">
          <h2>Your wishlist <span>{saved.length}</span></h2>
          <button ref={closeRef} type="button" className="btn btn--sm" onClick={close} aria-label="Close wishlist">Close</button>
        </header>

        {saved.length === 0 ? (
          <div className="wd__empty">
            <HeartIcon size={36} />
            <p><strong>Nothing saved yet</strong></p>
            <p>Tap the heart on any product to keep it here.</p>
            <Link className="btn btn--cobalt" to="/shop" onClick={close}>Browse the shop</Link>
          </div>
        ) : (
          <ul className="wd__list">
            {saved.map(p => {
              const img = gallery(p)[0]
              const { price, was } = pricing(p)
              const st = stock(p)
              const hue = p.hue ?? 210
              return (
                <li key={p.id} className="wd__item">
                  <Link to={`/product/${p.id}`} onClick={close} className="wd__img" aria-label={p.name}
                    style={{ background: `linear-gradient(145deg, hsl(${hue} 35% 94%), hsl(${hue} 45% 80%))` }}>
                    {img && <img src={img} alt="" loading="lazy" />}
                  </Link>
                  <div className="wd__info">
                    <Link to={`/product/${p.id}`} onClick={close} className="wd__name">{p.name}</Link>
                    <p className="wd__price">
                      {p.models ? 'From ' : ''}<strong className={was ? 'wd__now' : undefined}>{inr(price)}</strong>
                      {was && <s>{inr(was)}</s>}
                    </p>
                    {st !== 'in'
                      ? <span className="wd__off">{STOCK_LABEL[st]}</span>
                      : p.models
                        ? <Link className="btn btn--navy btn--sm" to={`/product/${p.id}`} onClick={close}>Choose model</Link>
                        : <button type="button" className="btn btn--navy btn--sm" onClick={() => dispatch({ type: 'add', item: { id: p.id, name: p.name, price } })}>Add to cart</button>}
                  </div>
                  <button type="button" className="wd__remove" onClick={() => toggleWish(p.id)} aria-label={`Remove ${p.name} from wishlist`}>
                    <HeartIcon filled size={18} />
                  </button>
                </li>
              )
            })}
          </ul>
        )}
      </aside>
    </div>,
    document.body,
  )
}